// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sem-hidden-value-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-family: inherit;
  transition: background-color 0.2s ease;
  min-height: 36px;  
  align-items: center;
  justify-content: center;
  display: block;
  position: absolute;
  top: 20px;
}

.sem-hidden-value-button:hover:not(:disabled) {
  background-color: #0056b3;
  border-color: #0056b3;
}

.sem-hidden-value-button:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

.sem-hidden-value-button:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.sem-hidden-value-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.sem-hidden-value-error {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #dc3545;
  font-size: 14px;
  padding: 8px 0;
}

.sem-hidden-value-unauthorized {
  display: flex;
  align-items: center;
  color: #ffc107;
  font-size: 14px;
  padding: 8px 0;
  font-weight: 500;
}

.retry-button {
  background-color: #dc3545;
  color: white;
  border: 1px solid #dc3545;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  align-self: flex-start;
  transition: background-color 0.2s ease;
}

.retry-button:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
}

.retry-button:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.sem-hidden-value-display {
  display: flex;
  flex-direction: column;
}

.readonly-value {
  background-color: #f8f9fa !important;
  cursor: default !important;
  border-color: #dee2e6 !important;
}

.readonly-value:focus {
  box-shadow: none !important;
  border-color: #dee2e6 !important;
}

.disabled-field {
  opacity: 0.6;
  cursor: not-allowed !important;
}

.binding-prop-name {
  font-size: 10px;
  color: #6c757d;
  margin: 4px 0 0 0;
  font-family: monospace;
}

/* Inherit existing sem-text-box styling */
.sem-text-box {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.sem-text-box:focus {
  outline: 0;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.is-invalid {
  border-color: #dc3545;
}

.inline-search-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
}

.hidden-value-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;  
}

.hidden-input-with-icon {
  padding-right: 35px !important;
}

.reveal-icon-btn-inside {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
}

.reveal-icon-btn-inside:hover {
  color: #333;
}

.reveal-icon-btn-inside mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.copy-btn:hover {
  color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-hidden-value/sem-hidden-value.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".sem-hidden-value-button {\r\n  background-color: #007bff;\r\n  color: white;\r\n  border: 1px solid #007bff;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  transition: background-color 0.2s ease;\r\n  min-height: 36px;  \r\n  align-items: center;\r\n  justify-content: center;\r\n  display: block;\r\n  position: absolute;\r\n  top: 20px;\r\n}\r\n\r\n.sem-hidden-value-button:hover:not(:disabled) {\r\n  background-color: #0056b3;\r\n  border-color: #0056b3;\r\n}\r\n\r\n.sem-hidden-value-button:focus {\r\n  outline: 2px solid #007bff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.sem-hidden-value-button:disabled {\r\n  background-color: #6c757d;\r\n  border-color: #6c757d;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.sem-hidden-value-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #666;\r\n  font-size: 14px;\r\n  padding: 8px 0;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 2px solid #f3f3f3;\r\n  border-top: 2px solid #007bff;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.sem-hidden-value-error {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  color: #dc3545;\r\n  font-size: 14px;\r\n  padding: 8px 0;\r\n}\r\n\r\n.sem-hidden-value-unauthorized {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #ffc107;\r\n  font-size: 14px;\r\n  padding: 8px 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.retry-button {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  border: 1px solid #dc3545;\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  align-self: flex-start;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.retry-button:hover:not(:disabled) {\r\n  background-color: #c82333;\r\n  border-color: #c82333;\r\n}\r\n\r\n.retry-button:disabled {\r\n  background-color: #6c757d;\r\n  border-color: #6c757d;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.sem-hidden-value-display {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.readonly-value {\r\n  background-color: #f8f9fa !important;\r\n  cursor: default !important;\r\n  border-color: #dee2e6 !important;\r\n}\r\n\r\n.readonly-value:focus {\r\n  box-shadow: none !important;\r\n  border-color: #dee2e6 !important;\r\n}\r\n\r\n.disabled-field {\r\n  opacity: 0.6;\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.binding-prop-name {\r\n  font-size: 10px;\r\n  color: #6c757d;\r\n  margin: 4px 0 0 0;\r\n  font-family: monospace;\r\n}\r\n\r\n/* Inherit existing sem-text-box styling */\r\n.sem-text-box {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  line-height: 1.5;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.sem-text-box:focus {\r\n  outline: 0;\r\n  border-color: #80bdff;\r\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n.is-invalid {\r\n  border-color: #dc3545;\r\n}\r\n\r\n.inline-search-wrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 10;\r\n  cursor: pointer;\r\n}\r\n\r\n.hidden-value-input-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;  \r\n}\r\n\r\n.hidden-input-with-icon {\r\n  padding-right: 35px !important;\r\n}\r\n\r\n.reveal-icon-btn-inside {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  color: #666;\r\n  transition: color 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 15;\r\n}\r\n\r\n.reveal-icon-btn-inside:hover {\r\n  color: #333;\r\n}\r\n\r\n.reveal-icon-btn-inside mat-icon {\r\n  font-size: 18px;\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.copy-btn:hover {\r\n  color: #007bff;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
